import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillPage } from '@/app/modules/ppt/pages/bill/ppt-bill.component';

export const routes: Routes = [
    {
        path: 'bill/:accountNumber/:taxYear',
        component: BillPage,
        data: { title: 'Bill', reuse: false },
        resolve: { forceRepaint: 'forceRepaintResolver' }
    },
    {
        path: 'bill/:accountNumber',
        component: BillPage,
        data: { title: 'Bill', reuse: false },
        resolve: { forceRepaint: 'forceRepaintResolver' }
    },
    {
        path: '',
        redirectTo: '/lookup',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PPTRoutingModule { }
